// theme/AppTheme.ts
import { createTheme } from "@mui/material";

export const AppTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#128C7E",
      light: "#25D366",
      dark: "#075E54",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#25D366",
      light: "#6EE89C",
      dark: "#1A7E59",
      contrastText: "#FFFFFF",
    },
    success: { main: "#25D366" },
    info: { main: "#34B7F1" },
    warning: { main: "#FFAB00" },
    error: { main: "#D32F2F" },
    background: {
      default: "#F0F2F5",
      paper: "#FFFFFF",
    },
    text: {
      primary: "#202124",
      secondary: "#4F5B62",
    },
    divider: "#E0E0E0",
  },

  typography: {
    fontFamily: [
      "Inter",
      "Roboto",
      '"Segoe UI"',
      "-apple-system",
      "BlinkMacSystemFont",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
    ].join(","),
    h1: { fontSize: "2.25rem", fontWeight: 700 },
    h2: { fontSize: "1.75rem", fontWeight: 600 },
    h3: { fontSize: "1.5rem", fontWeight: 600 },
    button: { textTransform: "none", fontWeight: 600 },
  },

  shape: { borderRadius: 10 },

  components: {
    /* -----------------------------------------------------------
       GLOBAL / COMMON
    ----------------------------------------------------------- */

    /* -----------------------------------------------------------
       APP CHROME
    ----------------------------------------------------------- */
    MuiAppBar: {
      defaultProps: { elevation: 0 },
      styleOverrides: {
        colorPrimary: {
          backgroundImage:
            "linear-gradient(90deg, #075E54 0%, #128C7E 50%, #25D366 100%)",
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: "#FFFFFF",
          borderRight: "1px solid #ECEFF1",
        },
      },
    },

    /* -----------------------------------------------------------
       BUTTONS
    ----------------------------------------------------------- */
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: { borderRadius: 10, fontWeight: 600 },
        containedPrimary: { "&:hover": { backgroundColor: "#0E725F" } },
        containedSecondary: { "&:hover": { backgroundColor: "#1F9E5F" } },
      },
    },

    /* -----------------------------------------------------------
       BADGE & ALERTS
    ----------------------------------------------------------- */
    MuiBadge: {
      styleOverrides: {
        badge: {
          padding: 0,
          backgroundColor: "#F44336",
          color: "#FFFFFF",
          fontWeight: 600,
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        standardSuccess: { backgroundColor: "#E8F5E9" },
        standardInfo: { backgroundColor: "#E3F2FD" },
        standardError: { backgroundColor: "#FFEBEE" },
        standardWarning: { backgroundColor: "#FFF8E1" },
      },
    },

    /* -----------------------------------------------------------
       CHIP
    ----------------------------------------------------------- */
    MuiChip: {
      styleOverrides: {
        root: { borderRadius: 8, fontWeight: 500 },
        colorPrimary: { backgroundColor: "#E0F2F1", color: "#075E54" },
      },
    },

    /* -----------------------------------------------------------
       TABLE – “nice & standard”
    ----------------------------------------------------------- */
    MuiTableContainer: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          border: "1px solid #E0E0E0",
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: "#ECEFF1",
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          "&:nth-of-type(odd)": { backgroundColor: "#FAFAFA" }, // subtle zebra-striping
          "&:hover": { backgroundColor: "#E3F2FD" }, // row hover
          "&.Mui-selected": { backgroundColor: "#D0E8E2 !important" }, // when using checkboxes
        },
        head: {
          "& th": {
            fontWeight: 700,
            color: "#202124",
            borderBottom: "2px solid #D6DADF",
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: "1px solid #E0E0E0",
          paddingTop: 10,
          paddingBottom: 10,
        },
        head: {
          fontSize: "0.875rem",
          textTransform: "uppercase",
          letterSpacing: 0.5,
        },
        body: {
          fontSize: "0.925rem",
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        toolbar: { paddingRight: 0 },
        actions: { marginLeft: 8 },
      },
    },
  },
});
